import { convertControlsToCSS, convertControlsToObject, Controls } from '../../controls/converters/index.js';
import { convertShadowsToCSS, convertShadowsToObject, Shadows } from '../../shadows/converters/index.js';
import { convertAccentsToCSS, convertAccentIllustrationsToCSS, convertAccentsToObject, convertAccentIllustrationsToObject, Accents, AccentIllustrations } from '../../accents/converters/index.js';
import '../../accents/accents/index.js';
import { convertBackgroundsToCSS, convertBackgroundsToObject, Backgrounds } from '../../backgrounds/converters/index.js';
import '../../backgrounds/backgrounds/index.js';
import { convertTextsToCSS, convertTextsToObject, Texts } from '../../texts/converters/index.js';
import '../../texts/texts/index.js';
import { convertPremiumToCSS, convertPremiumToObject, Premium } from '../../premium/converters/index.js';
import { convertStatusesToCSS, convertStatusesToObject, Statuses } from '../../statuses/converters/index.js';
import { convertAbsolutesToCSS, convertAbsolutesToObject, Absolutes } from '../../absolutes/converters/index.js';
import { convertMarketsToCSS, convertMarketsToObject, Markets } from '../../market/converters/index.js';
import { convertTransformerToCSS, convertTransformerToObject, Transformer } from '../../transformer/converters/index.js';
import { convertExternalBrandToCSS, convertExternalBrandToObject, ExternalBrand } from '../../externalBrand/converters/index.js';

const convertThemeToCSS = (theme) => (Object.freeze({
    ...convertAccentsToCSS(theme.accents),
    ...convertAccentIllustrationsToCSS(theme.accentIllustrations),
    ...convertBackgroundsToCSS(theme.backgrounds),
    ...convertTextsToCSS(theme.texts),
    ...convertPremiumToCSS(theme.premium),
    ...convertStatusesToCSS(theme.statuses),
    ...convertShadowsToCSS(theme.shadows),
    ...convertMarketsToCSS(theme.markets),
    ...convertAbsolutesToCSS(theme.absolutes),
    ...convertControlsToCSS(theme.controls),
    ...convertExternalBrandToCSS(theme.externalBrand),
    ...convertTransformerToCSS(theme.transformer),
}));
const convertThemeToObject = (theme) => (Object.freeze({
    ...convertAccentsToObject(theme.accents),
    ...convertAccentIllustrationsToObject(theme.accentIllustrations),
    ...convertBackgroundsToObject(theme.backgrounds),
    ...convertTextsToObject(theme.texts),
    ...convertPremiumToObject(theme.premium),
    ...convertStatusesToObject(theme.statuses),
    ...convertShadowsToObject(theme.shadows),
    ...convertMarketsToObject(theme.markets),
    ...convertAbsolutesToObject(theme.absolutes),
    ...convertControlsToObject(theme.controls),
    ...convertExternalBrandToObject(theme.externalBrand),
    ...convertTransformerToObject(theme.transformer),
}));
const Theme = {
    accents: Accents,
    accentIllustrations: AccentIllustrations,
    backgrounds: Backgrounds,
    texts: Texts,
    statuses: Statuses,
    premium: Premium,
    shadows: Shadows,
    markets: Markets,
    absolutes: Absolutes,
    controls: Controls,
    externalBrand: ExternalBrand,
    transformer: Transformer,
};

export { Theme, convertThemeToCSS, convertThemeToObject };
